import { render, staticRenderFns } from "./serviceInformationDialogNew.vue?vue&type=template&id=90944c08&scoped=true&"
import script from "./serviceInformationDialogNew.vue?vue&type=script&lang=js&"
export * from "./serviceInformationDialogNew.vue?vue&type=script&lang=js&"
import style0 from "./serviceInformationDialogNew.vue?vue&type=style&index=0&id=90944c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90944c08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90944c08')) {
      api.createRecord('90944c08', component.options)
    } else {
      api.reload('90944c08', component.options)
    }
    module.hot.accept("./serviceInformationDialogNew.vue?vue&type=template&id=90944c08&scoped=true&", function () {
      api.rerender('90944c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/serviceInformationDialogNew.vue"
export default component.exports